import React from "react";
import { Popover, Table, Whisper } from "rsuite";
import { useTranslation } from "react-i18next";
import {
  isEmptyVal,
  isNotEmpty,
  displayField,
  processSecond,
} from "../../../utils/helpers";

const CommercialInfoCell = ({
  dataKey,
  rowData,
  showData,
  ...props
}: {
  dataKey?: string;
  rowData: any;
  showData: any;
}) => {
  const { t } = useTranslation();
  const { Cell } = Table;
  const speaker = (
    <Popover title={t("COMMERCIAL") + " " + t("INFO")}>
      {showData.includes("title") && (
        <p>
          <b>{t("TITLE")} : </b>
          {displayField(rowData?.title)}
        </p>
      )}
      {showData.includes("media_nature") && (
        <p>
          <b>{t("TYPE")} : </b>
          {displayField(rowData?.media_nature)}
        </p>
      )}

      {showData.includes("commercial_use_for") && (
        <p>
          <b>
            {t("USED")} {t("FOR")}:{" "}
          </b>
          {displayField(rowData?.commercial_use_for)}
        </p>
      )}

      {showData.includes("media_type") && (
        <p>
          <b>
            {t("MEDIA")} {t("TYPE")} :{" "}
          </b>
          {displayField(rowData?.media_type)}
        </p>
      )}
      {showData.includes("media_category") && (
        <p>
          <b>{t("CATEGORY")} : </b>
          {displayField(rowData?.media_category)}
        </p>
      )}
      {showData.includes("media_duration") && (
        <p>
          <b>{t("DURATION")} : </b>
          {processSecond(parseInt(rowData?.media_duration))}
        </p>
      )}
      {showData.includes("brand_name") && (
        <p>
          <b>{t("BRAND")} : </b>
          {displayField(rowData?.brand_name)}
        </p>
      )}
      {showData.includes("campaign_name") && (
        <p>
          <b>{t("CAMPAIGN")} : </b>
          {displayField(rowData?.campaign_name)}
        </p>
      )}

      {showData.includes("sourced_from") && (
        <p>
          <b>
            {t("SOURCED")} {t("FROM")} :{" "}
          </b>
          {displayField(rowData?.sourced_from)}
        </p>
      )}
    </Popover>
  );

  return (
    <Cell {...props}>
      <Whisper
        placement="top"
        speaker={speaker}
        enterable={true}
        preventOverflow={true}
      >
        <a>{isEmptyVal(dataKey) ? t("INFO") : rowData[dataKey]}</a>
      </Whisper>
    </Cell>
  );
};

export default CommercialInfoCell;
